import { createFileObject } from "../helpers/format";
import { api } from "./api";

export const storeRegister = async (body: {
  name: string;
  email: string;
  phone: string;
  document: string;
  birthDate: Date | string;
  password: string;
  confirm?: string;
  cardNumber?: string;
  expireDate?: string;
  cvv?: string;
  cardName?: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  complement: string;
  cep: string;
  documentUser: string;
  userName: string;
  planId: string | number;
}): Promise<any> => {
  const { data } = await api.post("/store/register", body);
  return data;
};

export const getStorePlans = async (): Promise<unknown[]> => {
  const { data } = await api.get("/store/plans-list");
  return data;
};

export const phoneValidator = async (body: {
  phone: string;
}): Promise<unknown[]> => {
  const { data } = await api.post("/store/validate", body);
  return data;
};

export const myPlan = async (): Promise<any> => {
  const { data } = await api.get("/store/my-plan");
  return data;
};

export const updateStoreUser = async (body: {
  id: string | number;
  fullName?: string;
  email?: string;
  phone?: string;
}): Promise<any> => {
  const { data } = await api.put("/store/users/update", body);
  return data;
};

export const updateStore = async (body: {
  id: string | number;
  name: string;
  email: string;
  document: string;
  cep: string;
  street: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
  logo?: string | null;
  [key: string]: any;
}): Promise<any> => {
  const formData = new FormData();
  const fileData = createFileObject(body.logo);

  if (fileData && fileData.uri) {
    try {
      const response = await fetch(fileData.uri);
      const blob = await response.blob();

      formData.append("file", blob, fileData.name);
    } catch {
      formData.append("file", "");
    }
  }

  delete body.logo;

  for (var key in body) {
    formData.append(key, body[key]);
  }

  const { data } = await api.put("/store/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const createStoreOnPlan = async (body: {
  id: string | number;
  planId: string | number;
}): Promise<any> => {
  const { data } = await api.post("/store/register-store-plan", body);
  return data;
};

export const extendFreePeriod = async (): Promise<any> => {
  const { data } = await api.put("/store/extend-free-period");
  return data;
};

export const fightCreateGraduation = async (body: {
  id?: number;
  color: string;
  belt: string;
  minClass: string;
  minMonthTime: string;
  fightsId: string;
}): Promise<any> => {
  const { data } = await api.post("/store/fights/graduation/", body);
  return data;
};

export const fightDeleteGraduation = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("/store/fights/graduation/delete", body);
  return data;
};

export const fightOrderGraduation = async (body: unknown): Promise<any> => {
  const { data } = await api.put("/store/fights/graduation/order", body);
  return data;
};

export const fightUpdateGraduation = async (body: {
  id: number | string;
  color: string;
  belt: string;
  minClass: string;
  minMonthTime: string;
}): Promise<any> => {
  const { data } = await api.put("/store/fights/graduation", body);
  return data;
};

export const graduationColors = async (): Promise<any> => {
  const { data } = await api.get("/store/fights/graduation/colors");
  return data;
};

export const antecipationStatus = async (): Promise<any> => {
  const { data } = await api.put("/store/anticipation");
  return data;
};

export const antecipationGetStatus = async (): Promise<any> => {
  const { data } = await api.get("/store/anticipation");
  return data;
};

export const taxValues = async () => {
  const { data } = await api.get("/store/tax");

  return data;
};

export const configurationUpdate = async (body: any) => {
  const { data } = await api.put("/store/configuration", body);

  return data;
};

export const whatsappPopupDismissedUpdate = async (body: any) => {
  const { data } = await api.put("/store/whatsapp-popup-dismissed", body);

  return data;
};
